import { Dialog } from "@constellation-academy/epic-ui";
import { useFragment } from "react-relay";
import { useTranslation } from "@i18n/hooks";
import { messagePageFormDialog_PageFragment$key } from "@relay/messagePageFormDialog_PageFragment.graphql";
import { PAGE_FRAGMENT } from "./message-page-form-dialog.graphql";
import { MessagePageFormDialogProps } from "./message-page-form-dialog.types";
import { MessagePageForm } from "../message-page-form";

export const MessagePageFormDialog = ({
	pageFragmentRef,
	onHide,
	onSubmit,
	isVisible,
}: MessagePageFormDialogProps) => {
	const { t } = useTranslation("common");
	const page = useFragment<messagePageFormDialog_PageFragment$key>(
		PAGE_FRAGMENT,
		pageFragmentRef ?? null,
	);

	const dialogTitle = page
		? t("pages.editTitle", { title: page.internalTitle })
		: t("pages.createTitle");

	return (
		<Dialog visible={isVisible} onHide={onHide} title={dialogTitle}>
			<MessagePageForm pageFragmentRef={page} onSubmit={onSubmit} isCreating={!page} />
		</Dialog>
	);
};
